(function () {
  function initStickyAtc() {
    var bar = document.querySelector('[data-be-sticky-atc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyBtn = bar.querySelector('[data-be-sticky-submit]');
    if (!mainBtn || !stickyBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.hidden = visible;
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(mainBtn);

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      mainBtn.click();
    });

    function syncStickyButton() {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label) stickyBtn.textContent = label.textContent.trim();
    }

    syncStickyButton();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        requestAnimationFrame(syncStickyButton);
      });
    }

    var productInfo = document.querySelector('product-info');
    if (productInfo) {
      productInfo.addEventListener('change', function () {
        requestAnimationFrame(syncStickyButton);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('product-info:loaded', initStickyAtc);
})();
